export const defaultMetrics = [
  { key: 'ConversionsCredit', i18nKey: _TL_('Conversions') },
  { key: 'AdvertiserReportedRevenue', i18nKey: _TL_('Revenue') },
];
